import { useState } from 'react';
import {
  Button,
  Box,
  Chip,
  TextField,
  Typography,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './KeywordsEditor.scss';

const defaultProps = {
  keywords: [],
  onKeywordsUpdate: () => null,
  totalKeywordLimit: null,
  className: '',
  disabled: false,
};

export default function KeywordsEditor(props) {
  const {
    keywords,
    onKeywordsUpdate,
    totalKeywordLimit,
    className,
    disabled,
  } = { ...defaultProps, ...filterUndefined(props) };
  const shouldDisabled = totalKeywordLimit > 0 && keywords.join('').length >= totalKeywordLimit;

  const [keyworkText, setKeyworkText] = useState('');

  const handleOnKeywordTextChange = (e) => {
    e.stopPropagation();

    const currentKeywords = keywords.join('');
    const keywordsToUpdate = `${currentKeywords}${e.target.value}`;
    if (totalKeywordLimit > 0 && keywordsToUpdate.length >= totalKeywordLimit) {
      const remaining = totalKeywordLimit - currentKeywords.length;
      setKeyworkText(e.target.value.substring(0, remaining));
    } else {
      setKeyworkText(e.target.value);
    }
  };

  const handleOnKeywordAdd = (e) => {
    e.preventDefault();
    if (!keywords.includes(keyworkText)) {
      keywords.push(keyworkText);
      onKeywordsUpdate(keywords);
    }
    setKeyworkText('');
  };

  const handleOnKeywordDelete = (chipToDelete) => () => {
    const updatedKeyword = keywords.filter((k) => k !== chipToDelete);
    onKeywordsUpdate(updatedKeyword);
  };

  return (
    <div className={`keywords-editor ${className}`}>
      <form onSubmit={handleOnKeywordAdd} className='add-keyword'>
        <Typography variant='h5'>Keywords</Typography>
        <Box className='text-field'>
          <TextField
            fullWidth
            value={keyworkText}
            onChange={handleOnKeywordTextChange}
            disabled={shouldDisabled || disabled}
            placeholder={totalKeywordLimit > 0 ? `${totalKeywordLimit} characters total for keywords` : ''}
            inputProps={{
              'aria-label': 'Keyword Input',
            }}
          />
        </Box>
        <Button
          color='primary'
          type='submit'
          className='btn-primary'
          disabled={!keyworkText || shouldDisabled || disabled}
          aria-label='Add Keyword'
        >
          ADD
        </Button>
      </form>

      <div className='keywords'>
        {keywords.map((data, index) => {
          let icon;
          return (
            <Chip
              className='chip'
              key={index}
              icon={icon}
              label={data}
              onDelete={handleOnKeywordDelete(data)}
              disabled={disabled}
              aria-label={`Keyword: ${data}`}
            />
          );
        })}
      </div>
    </div>
  );
}
